if(!customElements.get('custom-search-product-list')){
    class SearchProductList extends HTMLElement {
        constructor(){
            super();

            this.init();
        }

        init(){
            this.articleCards = this.querySelectorAll('.article-card');

            this.adjustArticleCardHeight();
            window.addEventListener('resize', this.adjustArticleCardHeight.bind(this), false);

            // adjust margin top for header space
            this.adjustTopMarginSpace();

            // predictive search
            this.inputSearch = this.querySelector('.input-search');
            this.inputSearch.addEventListener('input', this.debounce((e) => {
                // show new search result
                this.updateSearchInput();
            }, 300).bind(this));

            this.formSearch = this.querySelector('#form-search');
            this.inputs = this.formSearch.querySelectorAll('input');

            this.formFacetFilter = this.querySelector('facet-filters-form');

            this.btnColumnSwitch = this.querySelector('.product-view-switch-wrapper');
            if(this.btnColumnSwitch){
                this.btnColumnSwitch.addEventListener('click', this.updateNumColumns.bind(this));
                this.btnColumnSwitch.addEventListener('keydown', e => {
                    if(e.key === 'Enter'){
                        this.updateNumColumns(e);
                    }
                })
            }

            this.btnClose = this.querySelector('.btn-close');
            if(this.btnClose){
                this.btnClose.addEventListener('click', this.debounce((e) => {
                    this.inputSearch.value = '';
                    
                    // show cleared search result
                    this.updateSearchInput();
                }));
            }
        }

        refresh(){
            this.init();
        }

        adjustArticleCardHeight(){
            this.articleCards.forEach(card => {
                const contentWrapper = card.querySelector('.article-card__content-wrapper');
                const dummyWrapper = card.querySelector('.article-card__image-wrapper--dummy');
                const imageRatio = (dummyWrapper.dataset.imageRatio === 'portrait')? "120%" : "100%";
        
                if(contentWrapper.offsetHeight > dummyWrapper.offsetHeight){
                    dummyWrapper.style.paddingTop = `max(${imageRatio}, ${contentWrapper.offsetHeight}px)`;
                }else{
                    dummyWrapper.style.paddingTop = imageRatio;
                }
            })
        }

        debounce(fn, wait){
            let t;
            return (...args) => {
                clearTimeout(t);
                t = setTimeout(() => fn.apply(this.args), wait);
            }
        }

        updateSearchInput(){
            var params = new URLSearchParams();
            this.inputs.forEach(item => {
                params.append(item.name, item.value);
            })
            const queryString = params.toString();
            const formURL = this.formSearch.getAttribute('action');
            const currentURL = formURL + '?' + queryString;

            this.formFacetFilter.loadProducts(currentURL, true, true);
            this.formFacetFilter.updateURL(currentURL);
        }

        adjustTopMarginSpace(){
            var header = document.querySelector('custom-header');
            if(header && window.getComputedStyle(header).position === 'absolute'){
                var headerHeight = header.offsetHeight;
                this.style.paddingTop = `calc(${headerHeight}px + 2rem)`;
            }
        }

        updateNumColumns(){
            this.productCardWrapper = this.querySelectorAll('.product-card__wrapper, .article-card__wrapper, .page-card__wrapper');

            this.productCardWrapper.forEach(item => {
                if(this.btnColumnSwitch.dataset.column == '3'){
                    // update to 4 columns
                    item.classList.add('col-xl-4');
                    item.classList.add('col-12');
                    item.classList.remove('col-xl-3');
                    item.classList.remove('col-6');
                }else{
                    // update to 3 columns
                    item.classList.add('col-xl-3');
                    item.classList.add('col-6');
                    item.classList.remove('col-xl-4');
                    item.classList.remove('col-12');
                }
            });

            if(this.btnColumnSwitch.dataset.column == '4'){
                this.btnColumnSwitch.setAttribute('data-column', '3');
            }else{
                this.btnColumnSwitch.setAttribute('data-column', '4');
            }
        }
    }
    customElements.define('custom-search-product-list', SearchProductList);
}